import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Drive de Arquivos',
    path: '/ferramentas/drive_arquivos/arquivos',
    name: 'drive_arquivos',
    component: () => import('@/views/ferramentas/drive_arquivos/Index.vue'),
    meta: {
      isLegacy: false,
      permissions: [
        eTipoPermissao.FERRAMENTAS_ARQUIVOS_MENU_2500500100
      ],
    },
    goesToMenu: true,
  },
]

